import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/location-alert.svg")